import { useQuery } from '@tanstack/react-query'

import { EligibilityFactorsResponse } from '@appTypes/PagesApi.interface'

import { handleApiResponse } from './utils/handleApiResponse'

interface Options {
    body: {
        customerId: string
    }
    shouldFetchEligibilityFactors: boolean
}

export const useEligibilityFactorsQuery = ({
    body,
    shouldFetchEligibilityFactors,
}: Options) => {
    return useQuery<EligibilityFactorsResponse>(
        ['eligibilityFactors', body.customerId],
        () =>
            fetch(
                `${process.env.NEXT_PUBLIC_BASE_PATH}/api/eligibility-factors/`,
                {
                    body: JSON.stringify(body),
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json',
                    },
                }
            ).then(handleApiResponse),
        {
            staleTime: Infinity,
            retry: false,
            refetchOnWindowFocus: false,
            enabled: shouldFetchEligibilityFactors,
        }
    )
}
